import { motion } from "framer-motion";
import { DEFAULT_COLORS } from "src/lib/constants";

interface SwatchesProps {
	value?: string;
	onChange: (value: string) => void;
}

const Swatches = ({ value, onChange }: SwatchesProps) => {
	return (
		<div className="flex flex-wrap gap-1">
			{DEFAULT_COLORS.map((color) => (
				<Swatch
					key={`color-${color}`}
					{...{ color }}
					active={color === value}
					onClick={() => onChange(color)}
				/>
			))}
		</div>
	);
};

interface SwatchProps {
	active: boolean;
	color: string;
	onClick: () => void;
}

const Swatch = ({ active, color, onClick }: SwatchProps) => {
	return (
		<motion.div
			{...{ onClick }}
			animate={active ? "active" : "inactive"}
			whileHover="active"
			style={{ border: `2px solid ${color}` }}
			className={`flex aspect-video h-7 rounded-sm cursor-pointer relative`}
		>
			<motion.div
				variants={{
					active: {
						opacity: 1,
					},
					inactive: {
						opacity: 0,
					},
				}}
				className="absolute rounded-sm"
				style={{
					backgroundColor: color,
					left: 2,
					right: 2,
					top: 2,
					bottom: 2,
				}}
			/>

			<motion.div
				variants={{
					active: {
						opacity: 0,
					},
					inactive: {
						opacity: 1,
					},
				}}
				className="absolute inset-0"
				style={{
					backgroundColor: color,
					left: 0,
					right: 0,
					top: 0,
					bottom: 0,
				}}
			/>
		</motion.div>
	);
};

export default Swatches;
